module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [(_vm.isSharedToYou) ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('static.sharedWarehouse.notAllowed')))])])], 1) : _c('div', [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 12
    }
  }, [_c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-list-alt",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.purchase.update.title')) + " - " + _vm._s(_vm.$t('static.purchase.status.' + _vm.purchaseTitle)))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('br'), _c('br')]) : _c('div', {
    staticClass: "whiteWrapper"
  }, [_c('el-tabs', {
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('form.purchase.basicInformation'),
      "name": "first"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 12,
      "span": 24
    }
  }, [(!_vm.loading) ? _c('v-form', {
    attrs: {
      "form": _vm.formBasicInformation,
      "translation": "form.purchase",
      "hasLabel": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "span": 24
    }
  }, [_c('div', {
    staticClass: "btn-group margin-r-10"
  }, [_c('el-button', {
    staticClass: "btn btn-danger dropdown-toggle dropdown-toggle-split small",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    },
    on: {
      "click": _vm.toggleDropdown
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('static.purchase.view.documentBtnDropdown')) + " "), _c('span', {
    staticClass: "sr-only"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    class: {
      show: _vm.dropdownState
    }
  }, [_c('a', {
    staticClass: "dropdown-item small",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.previewSendDocument
    }
  }, [_vm._v(_vm._s(_vm.$t('static.purchase.view.sendPurchaseDocument')))]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item small",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.downloadPurchase
    }
  }, [_vm._v(_vm._s(_vm.$t('static.purchase.view.downloadPurchaseDocument')))])])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('v-products-table', {
    attrs: {
      "disableForm": _vm.isDisableForm,
      "fields": _vm.fields,
      "translation": "table.productsCustom",
      "page": "purchase"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "full-w flex justify-center buttons_under_main_body"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'inventory.purchase.index'
      }
    }
  }, [_c('el-button', {
    staticClass: "dark"
  }, [_vm._v(_vm._s(_vm.$t('button.close').toUpperCase()))])], 1), _vm._v(" "), (_vm.showCancelPurchase) ? _c('el-button', {
    staticClass: "outline danger",
    attrs: {
      "loading": _vm.formBasicInformation.loading
    },
    on: {
      "click": _vm.cancelPurchase
    }
  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))]) : _vm._e(), _vm._v(" "), (_vm.showDraft) ? _c('el-button', {
    staticClass: "outline",
    attrs: {
      "loading": _vm.formBasicInformation.loading
    },
    on: {
      "click": _vm.updateDraft
    }
  }, [_vm._v(_vm._s(_vm.$t('button.updateDraft').toUpperCase()))]) : _vm._e(), _vm._v(" "), (_vm.showSave) ? _c('el-button', {
    staticClass: "outline",
    attrs: {
      "loading": _vm.formBasicInformation.loading
    },
    on: {
      "click": function($event) {
        return _vm.store()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))]) : _vm._e(), _vm._v(" "), (_vm.showComplete) ? _c('el-button', {
    staticClass: "outline",
    attrs: {
      "loading": _vm.formBasicInformation.loading
    },
    on: {
      "click": _vm.markAsDone
    }
  }, [_vm._v(_vm._s(_vm.$t('button.complete').toUpperCase()))]) : _vm._e()], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e4b3e86","hasScoped":true}!./src/app/pages/withNavigation/purchase/edit/edit.html
// module id = 3055
// module chunks = 1